/**
 * Card Material Progress helpers.
 *
 * Mirrors backend `_progress_key` — the canonical key for a consolidated
 * material row on any of the 3 WO Card surfaces (Open WO sidebar,
 * Dispatch board cell + popover, Tech /field card). Uses lowercase
 * part_number when present, otherwise lowercase description. Same hash
 * already drives parts consolidation in the dispatch queue, so a
 * checkbox in the DoneForDayModal lines up 1:1 with each row across
 * every card.
 */

export function progressKeyFor(part) {
  if (!part) return "";
  const pn = (part.part_number || "").trim().toLowerCase();
  if (pn) return pn;
  return (part.description || "").trim().toLowerCase();
}

export function isPartChecked(part, progressList) {
  const k = progressKeyFor(part);
  if (!k || !Array.isArray(progressList)) return false;
  return progressList.some((p) => ((p?.key || "").toLowerCase() === k));
}
